// This file stores constant data used throughout the application.

// A predefined list of job titles for the employee creation form.
// Using a constant list like this ensures data consistency.
export const JOB_TITLES = [
    "Care Giver",
    "Senior Care Giver",
    "Registered Nurse",
    "Team Lead",
    "Field Supervisor",
    "Care Coordinator",
    "Physiotherapist",
    "Office Staff",
];

// --- BLEEP SERVER IDENTIFIERS & DISPLAY NAMES ---
export const BLEEP_SERVER_IDS = [
    '360camhs.co.uk',
    '360communitycare.co.uk',
    '360complexcare.co.uk',
    '360supportedliving.co.uk',
];

export const BLEEP_SERVER_NAMES = {
    '360camhs.co.uk': '360 CAMHS',
    '360communitycare.co.uk': '360 Community Care',
    '360complexcare.co.uk': '360 Complex Care',
    '360supportedliving.co.uk': '360 Supported Living',
};

// --- CANDIDATE PURGATORY REVIEW STATUSES ---
export const PURGATORY_REVIEW_STATUSES = [
    'pending',
    'partially_approved',
    'approved',
    'rejected',
    'all',
];

// --- EMPLOYEE INACTIVITY OUTCOME CODES ---
export const INACTIVITY_OUTCOMES = {
    'all': 'All',
    'KEEP_ACTIVE': 'Keep active',
    'DUE_TO_TERMINATE': 'Due within 7 days',
    'WOULD_TERMINATE': 'Would terminate',
    'NEEDS_REVIEW': 'Needs review',
    'ALREADY_INACTIVE': 'Already inactive',
};

// --- EMPLOYEE INACTIVITY REASON EXPLANATIONS ---
export const INACTIVITY_REASONS = {
    'FUTURE_BOOKING': 'Has an upcoming visit or shift.',
    'ONGOING_BOOKING': 'Has a visit or shift currently in progress.',
    'START_DATE_IN_FUTURE': 'The employee start date is in the future.',
    'WITHIN_30_DAYS': 'Still within the 30-day inactivity period.',
    'WITHIN_7_DAYS': 'No upcoming booking; the 30-day threshold is within 7 days.',
    'OVER_30_DAYS_AND_NO_FUTURE_BOOKING': 'Over 30 days since the last qualifying booking.',
    'MISSING_OR_INVALID_START_DATE': 'No qualifying booking and start date needs checking.',
    'UNKNOWN_STATUS': 'Employee status is missing or is not true/false.',
    'LEFT_BUT_ACTIVE': 'Employee status is true but left is also true.',
    'ALREADY_INACTIVE': 'Employee status is already false.',
    'DATA_OR_SCAN_ISSUES': 'Some records need checking before a decision can be made.',
};

// --- EMPLOYEE INACTIVITY ISSUE TAGS ---
export const INACTIVITY_ISSUE_LABELS = {
    'EMPLOYEE_AUTH_NOT_FOUND': 'Auth record missing',
    'EMPLOYEE_AUTH_STATUS_MISMATCH': 'Auth status is not true',
    'ACTIVITY_SCAN_LIMIT_REACHED': 'Too many bookings',
    'UNRECOGNISED_VISIT_STATE': 'Visit status needs checking',
    'UNRECOGNISED_SHIFT_STATE': 'Shift status needs checking',
    'INVALID_ACTIVITY_DATES': 'Booking dates invalid',
    'ASSIGNMENT_MISMATCH': 'Employee assignment mismatch',
    'UNRESOLVED_SHIFT_IDENTITY': 'Unresolved migration identity',
};

// --- EMPLOYEE INACTIVITY REPORT VIEW TABS ---
export const INACTIVITY_REPORT_VIEWS = {
    'NEWLY_ADDED': 'Newly added accounts',
    'RECENTLY_TERMINATED': 'Recently terminated',
    'LONG_TERM_TERMINATED': 'Long term terminated',
    'TERMINATION_DATE_UNKNOWN': 'Termination date unknown',
};

// --- MONTHLY SNAPSHOT RECORD KINDS ---
export const MONTHLY_SNAPSHOT_KINDS = {
    'ALL': 'All records',
    'ACCOUNT_ADDED': 'Accounts added',
    'HA_TERMINATED': 'Terminations',
    'HA_RESTORED': 'Restorations',
    'DATA_ISSUE': 'Data issues',
};

// --- MONTHLY EMAIL AUDIT LABELS ---
export const MONTHLY_MAIL_LABELS = {
    'QUEUED': 'Queued',
    'PROCESSING': 'Processing',
    'PREVIEW_READY': 'Preview ready · nothing sent',
    'NO_RECIPIENTS': 'No eligible recipients',
    'COMPLETE': 'SMTP processing complete',
    'COMPLETE_WITH_ISSUES': 'Completed with issues',
    'SMTP_ACCEPTED': 'Accepted by SMTP',
    'PREVIEW_ONLY': 'Preview only · nothing sent',
    'NOT_RECORDED': 'No send recorded',
    'SENDING': 'Send started · outcome not yet recorded',
    'REVIEW_REQUIRED': 'Needs review',
    'SKIPPED_INELIGIBLE': 'Skipped · no longer eligible',
    'STATUS_NOT_ACTIVE': 'Account status is not active',
    'ACTIVE_FALSE': 'Active flag is false',
    'DISABLED': 'Account disabled',
    'LEFT': 'Account marked as left',
    'SUSPENDED_BY_SYSTEM': 'Suspended by system',
    'EMAIL_MISSING': 'Email missing',
    'EMAIL_INVALID': 'Email invalid',
    'DUPLICATE_EMAIL': 'Email already selected for another admin',
    'PREVIOUS_SEND_OUTCOME_UNKNOWN': 'Previous send outcome is unknown',
    'SMTP_OR_POST_SEND_LOG_FAILED': 'Send or post-send logging failed',
};